import Switch from '@mui/material/Switch';
import { alpha, styled } from '@mui/system';
import colors from '../../assets/colors';

const GreenSwitch = styled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: colors.agroweGreen,
    '&:hover': {
      backgroundColor: alpha(colors.agroweGreen, 0.2),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: colors.agroweGreen,
  },
});

export default GreenSwitch;
